export default "__VITE_ASSET__CIExPxyj__"